import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const getToken = () => {
  return localStorage.getItem("token");
};

axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      //window.location.reload();
    }

    return Promise.reject(error);
  }
);

const handleError = (error) => {
  let errors = [];
  let message = "Ocurrio un error desconocido";

  if (axios.isCancel(error)) {
    throw error;
  }

  if (error instanceof AxiosError) {
    const { status, data } = error.response;

    message = data?.message ? data.message : message;

    /* if (error.response) {
      const { status, data } = error.response;
      serverMessage = data?.message;
      errors = Array.isArray(data?.errors) ? data.errors : [];
    } else {
      const status = 500;
    } */

    if (status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");

      window.location.reload();
      return;
    }

    console.log("algo trono");

    toast.error(message);

    return { error: message };
  }

  // toast.error(message);

  return {
    error: message,
    errors,
  };
};

export const ApiHttp = {
  post: (url, data, config = {}) => {
    return axiosInstance
      .post(url, data, config)
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch(handleError);
  },
  put: (url, data, config = {}) => {
    return axiosInstance
      .put(url, data, config)
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch(handleError);
  },
  get: (url, config = {}) => {
    return axiosInstance
      .get(url, config)
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch(handleError);
  },
  delete: (url, config = {}) => {
    return axiosInstance
      .delete(url, config)
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch(handleError);
  },
};

export default axiosInstance;
